import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import styles from "./Sidebar.module.css";

const NAV = [
  { to: "/dashboard",    icon: "▦",  label: "Dashboard"    },
  { to: "/clients",      icon: "👥", label: "Clients"      },
  { to: "/finance",      icon: "📊", label: "Finance"      },
  { to: "/commissions",  icon: "💵", label: "Commissions"  },
  { to: "/jobs",         icon: "💼", label: "Job Listings" },
  { to: "/employees",    icon: "🏢", label: "Employees", adminOnly: true },
];

export default function Sidebar({ open, onClose }) {
  const { isAdmin, profile } = useAuth();

  return (
    <aside className={`${styles.sidebar} ${open ? styles.open : ""}`}>
      <div className={styles.brand}>
        <div className={styles.brandIcon}>RH</div>
        <div>
          <div className={styles.brandName}>Royal Horizon</div>
          <div className={styles.brandSub}>Management</div>
        </div>
        <button className={styles.closeBtn} onClick={onClose} aria-label="Close menu">✕</button>
      </div>

      <nav className={styles.nav}>
        <div className={styles.navGroup}>
          <div className={styles.navLabel}>Main</div>
          {NAV.filter((n) => !n.adminOnly || isAdmin).map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              onClick={onClose}
              className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
            >
              <span className={styles.icon}>{icon}</span>
              {label}
            </NavLink>
          ))}
        </div>
      </nav>

      <div className={styles.profileStrip}>
        <div className={styles.avatar}>
          {profile?.full_name?.[0]?.toUpperCase() ?? "?"}
        </div>
        <div>
          <div className={styles.profileName}>{profile?.full_name ?? "—"}</div>
          <div className={styles.profileRole}>{profile?.role ?? "—"}</div>
        </div>
      </div>
    </aside>
  );
}